// notificationSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import NotificationStatus from '../../types/notification';

export enum WebNotificationType {
  ACTIVITY = 'ACTIVITY',
  PAYMENT = 'PAYMENT',
}

export interface INotification {
  id: string;
  coachId: string;
  description: string;
  createdAt: string;
  status: NotificationStatus;
  title: string;
  isViewed: boolean;
  client: {
    id: string;
    profilePic: string;
    firstName: string;
    lastName: string;
  };
  type: WebNotificationType;
}

export interface ICoachWebNotificationPayload {
  coachId: string;
}

export interface IGetNotificationResponse {
  getWebNotifications: {
    webNotifications: INotification[];
    count: number;
    chatCount: number;
  };
}

export interface IGetNotificationsPayload {
  coachId: string;
  skip: number;
  take: number;
  searchQuery: string;
  isViewed?: boolean;
}

export interface NotificationsState {
  notifications: INotification[];
  count: number;
  loading: boolean;
  error: string | null;
}

const initialState: NotificationsState = {
  notifications: [],
  count: 0,
  loading: false,
  error: null,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    getNotificationsRequest(state, _action: PayloadAction<IGetNotificationsPayload>) {
      state.loading = true;
      state.error = null;
    },
    getNotificationsSuccess(state, action: PayloadAction<IGetNotificationResponse>) {
      state.loading = false;
      state.notifications = action.payload.getWebNotifications.webNotifications;
      state.count = action.payload.getWebNotifications.count;
    },
    getNotificationsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    coachWebNotificationsReceived(state, action: PayloadAction<INotification>) {
      state.notifications.unshift(action.payload);
      state.count += 1;
    },
    viewWebNotifications(_state, _action: PayloadAction<{ coachId: string }>) {},
    viewWebNotificationsSuccess(state) {
      state.notifications = state.notifications.map((notification) => ({
        ...notification,
        isViewed: true,
      }));
    },
    viewWebNotificationsFailure(_state) {},
  },
});

export const {
  getNotificationsRequest,
  getNotificationsSuccess,
  getNotificationsFailure,
  coachWebNotificationsReceived,
  viewWebNotifications,
  viewWebNotificationsSuccess,
  viewWebNotificationsFailure,
} = notificationSlice.actions;

export default notificationSlice.reducer;
